import { render, staticRenderFns } from "./AssignFileToCrew.vue?vue&type=template&id=244dd5b4&scoped=true&"
import script from "./AssignFileToCrew.vue?vue&type=script&lang=js&"
export * from "./AssignFileToCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244dd5b4",
  null
  
)

export default component.exports